import themePalette from "../../../../.brew-cache/theme.json";

export default theme => ({
    header: {
        display: 'block',
        position: 'relative',
        marginBottom: 24,
        // Foreground colours
        '&[data-text-color="primary"]': { color: themePalette.ThemeOptions.mainColours.primaryColour},
        '&[data-text-color="secondary"]': { color: themePalette.ThemeOptions.mainColours.secondaryColour},
        '&[data-text-color="tertiary"]': { color: themePalette.ThemeOptions.mainColours.tertiaryColour},
        '&[data-text-color="foreground_primary"]': { color: themePalette.ThemeOptions.foregroundColours.foregroundPrimaryColour},
        '&[data-text-color="foreground_secondary"]': { color: themePalette.ThemeOptions.foregroundColours.foregroundSecondaryColour},
        '&[data-text-color="foreground_tertiary"]': { color: themePalette.ThemeOptions.foregroundColours.foregroundTertiaryColour},
        '&[data-text-color="background_primary"]': { color: themePalette.ThemeOptions.backgroundColours.backgroundPrimaryColour},
        '&[data-text-color="background_secondary"]': { color: themePalette.ThemeOptions.backgroundColours.backgroundSecondaryColour},
        '&[data-text-color="background_tertiary"]': { color: themePalette.ThemeOptions.backgroundColours.backgroundTertiaryColour},
        // Background colours
        '&:not([data-bg-color="initial"])': {padding: 12},
        '&[data-bg-color="primary"]': { backgroundColor: themePalette.ThemeOptions.mainColours.primaryColour},
        '&[data-bg-color="secondary"]': { backgroundColor: themePalette.ThemeOptions.mainColours.secondaryColour},
        '&[data-bg-color="tertiary"]': { backgroundColor: themePalette.ThemeOptions.mainColours.tertiaryColour},
        '&[data-bg-color="foreground_primary"]': { backgroundColor: themePalette.ThemeOptions.foregroundColours.foregroundPrimaryColour},
        '&[data-bg-color="foreground_secondary"]': { backgroundColor: themePalette.ThemeOptions.foregroundColours.foregroundSecondaryColour},
        '&[data-bg-color="foreground_tertiary"]': { backgroundColor: themePalette.ThemeOptions.foregroundColours.foregroundTertiaryColour},
        '&[data-bg-color="background_primary"]': { backgroundColor: themePalette.ThemeOptions.backgroundColours.backgroundPrimaryColour},
        '&[data-bg-color="background_secondary"]': { backgroundColor: themePalette.ThemeOptions.backgroundColours.backgroundSecondaryColour},
        '&[data-bg-color="background_tertiary"]': { backgroundColor: themePalette.ThemeOptions.backgroundColours.backgroundTertiaryColour},
    },
    headerTheme: {
        ...theme.headerTheme,
    }
})